import React from "react"
import styled from 'styled-components'

const TableHeader = styled.div`
  color: white;
  box-sizing: border-box;
  text-align: left;
  width: ${props => props.width};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  float: left;
  padding-left: ${props => props.paddingLeft ? '20px' : '0'};
`
const Sorter = styled.a`
  color: white;
  &:hover { cursor: pointer }
`

class PipelineTableHeader extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      ascending: false,
      ...props
    }

    this.toggleSortOrder = this.toggleSortOrder.bind(this)
  }

  toggleSortOrder() {
    this.props.sortByKey(this.state.headerKey, this.state.ascending)
    this.setState({ ascending: !this.state.ascending })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps })
  }

  render() {
    const { ascending, title } = this.state

    return(
      <TableHeader width={this.props.width} paddingLeft={this.props.paddingLeft} paddingRight={this.props.paddingRight}>
        <Sorter onClick={this.toggleSortOrder}>
          {title} <i className={`fa fa-caret-${ascending ? 'up' : 'down'}`} />
        </Sorter>
      </TableHeader>
    )
  }
}

export default PipelineTableHeader;
